import AdminShell from '@/app/shells/AdminShell';
import TenantShell from '@/app/shells/TenantShell';
import { SHELL_IDS } from '@/app/router/route-registry';

const shellRegistry = {
  [SHELL_IDS.TENANT]: TenantShell,
  [SHELL_IDS.ADMIN]: AdminShell,
};

export function getShellComponent(shellId) {
  return shellRegistry[shellId] || null;
}
